import React from 'react';
import {
  FormControl,
  Typography,
  TextField,
  InputAdornment,
} from '@mui/material';
import { useField } from 'formik';
import { capitalize } from 'lodash';
import Label from './Label';

interface Props {
  label?: string;
  subLabel?: string;
  noLabel?: boolean;
  name: string;
  placeholder?: string;
  required?: boolean;
  readOnly?: boolean;
  postIcon?: JSX.Element;
  multiline?: boolean;
  type?: string;
  onIconClick?: () => void;
}
export default function FieldInput(props: Props) {
  const {
    label,
    noLabel,
    name,
    placeholder,
    required,
    readOnly,
    postIcon,
    multiline,
    type = 'text',
    onIconClick,
  } = props;

  const [field, meta] = useField(name);

  return (
    <FormControl
      className="flex flex-col gap-2 w-full relative min-h-[90px]"
      fullWidth
    >
      {!noLabel && <Label {...props} text={label || capitalize(name)} />}

      <TextField
        {...field}
        type={type}
        size="small"
        multiline={multiline}
        className="bg-surface-2 rounded-xl"
        placeholder={placeholder || capitalize(label) || capitalize(name)}
        sx={{
          '& fieldset': { border: 'none' },
          '& .Mui-focused': {
            border: '1px solid var(--accent)',
            backgroundColor: 'var(--surface)',
          },
        }}
        InputProps={{
          className: 'border border-transparent hover:border-text-2',
          readOnly,
          required,
          endAdornment: (
            <InputAdornment
              position="end"
              onClick={onIconClick}
              sx={{
                cursor: onIconClick ? 'pointer' : 'auto',
              }}
            >
              {postIcon}
            </InputAdornment>
          ),
        }}
      />

      {!!meta.touched && !!meta.error && (
        <div className="-bottom-0 absolute">
          <Typography variant="caption" color="error">
            {meta.error}
          </Typography>
        </div>
      )}
    </FormControl>
  );
}
